import React from 'react';

const Tabs = ({ isActive, setIsActive, bookRecordCount, contributorRecordCount, articleRecordCount }) => {
  const contentArr = [
    { name: 'books', display: false, tabKey: 'books_tab' },
    { name: 'contributors', display: false, tabKey: 'contributors_tab' },
    { name: 'articles', display: false, tabKey: 'articles_tab' }
  ];
  const handleActiveTab = ( name ) => setIsActive( name );
  const tabNames = window.DP.search_tab_names;

  if ( bookRecordCount > 0 ) {
    contentArr[0].display = true;
  }

  if ( contributorRecordCount > 0 ) {
    contentArr[1].display = true;
  }

  if ( articleRecordCount > 0 ) {
    contentArr[2].display = true;
  }

  // Keyboard handler for accessibility
  const handleKeyDown = ( e, name ) => {
    if ( e.key === 'Enter' || e.key === ' ' ) {
      e.preventDefault();
      handleActiveTab( name );
    }
  };

  return (
    <>
      <ul
        className='list-none flex gap-45 p-0 cursor-pointer search-tabs lg:m-auto max-w-lg px-5 sm:px-10 lg:px-0'
        role="tablist"
      >
        { contentArr.map( ( item ) => {
          if ( item.display ) {
            const isSelected = isActive === item.name;
            return (
              <li
                className={`${isSelected ? 'is-active' : ''} mb-0`}
                key={ self.crypto.randomUUID() }
                role="presentation"
              >
                <button
                  type="button"
                  role="tab"
                  id={`tab-${item.name}`}
                  aria-selected={isSelected}
                  aria-controls={`tabpanel-${item.name}`}
                  tabIndex={0}
                  data-name={item.name}
                  className="search-tab-btn"
                  onClick={ () => handleActiveTab( item.name ) }
                  onKeyDown={ ( e ) => handleKeyDown( e, item.name ) }
                >
                  { tabNames[item.tabKey] }
                </button>
              </li>
            );
          }
          return null;
        })}
      </ul>
    </>
  );
};

export default Tabs;
